import React, { Fragment, useEffect, useState } from 'react'
import LogoTitle from '../../assets/images/logo-q.png'
import { Link } from 'react-router-dom'
import '../Layout/Layout.scss'
import './Home.scss'
import AnimatedLetter from '../AnimatedLetter/AnimatedLetter'
import Logo from './Logo/Logo'
import Loader from 'react-loaders'

const Home = () => {
  /**
   * Animation when hover text
   */
  const [letterClass, setLetterClass] = useState('text-animate')

  /**
   * List Array wanted to hover
   */
  const nameArray = ['u', 'â', 'n']
  const jobArray = [
    's',
    'o',
    'f',
    't',
    ' ',
    'd',
    'e',
    'v',
    'e',
    'l',
    'o',
    'p',
    'e',
    'r',
    '.',
  ]

  useEffect(() => {
    setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 6000)
  }, [])

  return (
    <Fragment>
      <div className="container home-page">
        <div className="text-zone">
          <h1>
            <span className={letterClass}>H</span>
            <span className={`${letterClass} _2`}>i</span>
            <span className={`${letterClass} _3`}>,</span>
            <br />
            <span className={`${letterClass} _4`}>I</span>
            <span className={`${letterClass} _5`}>'</span>
            <span className={`${letterClass} _6`}>m</span>
            <div className="img-container">
              <img src={LogoTitle} alt="developer" />
            </div>

            <AnimatedLetter
              letterClass={letterClass}
              strArray={nameArray}
              idx={10}
            />
            <br />
            <AnimatedLetter
              letterClass={letterClass}
              strArray={jobArray}
              idx={20}
            />
          </h1>
          <h2>Full-Stack Developer | Mobile Developer</h2>
          <Link to="/contact" className="flat-button">
            CONTACT ME
          </Link>
        </div>
        <Logo />
      </div>

      <Loader type="pacman" />
    </Fragment>
  )
}

export default Home
